import { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { useUploadMedia } from '../../../api/media';

export function MediaUploader({ projectId }: { projectId: number }) {
  const uploadMutation = useUploadMedia(projectId);
  const inputRef = useRef<HTMLInputElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFiles = async (files: FileList | null) => {
    if (!files || files.length === 0) return;
    try {
      await uploadMutation.mutateAsync(Array.from(files));
      toast.success(`${files.length} file(s) uploaded`);
      if (inputRef.current) inputRef.current.value = '';
    } catch {
      toast.error('Upload failed');
    }
  };

  return (
    <div
      className={`border-2 border-dashed rounded-xl p-6 text-center transition-colors ${
        isDragging ? 'border-spi-green bg-spi-green/5' : 'border-spi-parchment hover:border-spi-green/50'
      }`}
      onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
      onDragLeave={() => setIsDragging(false)}
      onDrop={(e) => { e.preventDefault(); setIsDragging(false); handleFiles(e.dataTransfer.files); }}
    >
      <input
        ref={inputRef}
        type="file"
        multiple
        accept="image/jpeg,image/png,image/gif,image/webp,application/pdf,.doc,.docx"
        onChange={(e) => handleFiles(e.target.files)}
        className="hidden"
        id="media-upload"
      />
      <label htmlFor="media-upload" className="cursor-pointer">
        <svg className="w-10 h-10 mx-auto text-spi-slate/40 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <p className="text-sm text-spi-slate">
          {uploadMutation.isPending ? 'Uploading...' : 'Drop files here or click to upload'}
        </p>
        <p className="text-xs text-spi-slate/60 mt-1">Images (JPG, PNG, GIF, WebP) or Documents (PDF, DOC, DOCX). Max 10MB each.</p>
      </label>
    </div>
  );
}
